import { graphql } from "../generated";

export const AdvertsDocument = graphql(`
  query Adverts($projectKey: ID!) {
    adverts(orderKey: $projectKey, rootOnly: true) {
      nodes {
        integrationKey
      }
    }
  }
`);
